const districts = {
  Chandigarh: [{_id: '60f4666196d7b3151afffb73', name: 'Chandigarh'}],
  Assam: [
    {_id: '60f4666196d7b3151afffc7a', name: 'Baksa'},
    {_id: '60f4666196d7b3151afffd29', name: 'Barpeta'},
    {_id: '60f4666196d7b3151afffd30', name: 'Biswanath'},
    {_id: '60f4666196d7b3151afffcc2', name: 'Bongaigaon'},
    {_id: '60f4666196d7b3151afffcb9', name: 'Cachar'},
    {_id: '60f4666196d7b3151afffbb4', name: 'Chirang'},
    {_id: '60f4666196d7b3151afffc07', name: 'Darrang'},
    {_id: '60f4666196d7b3151afffbe1', name: 'Dhemaji'},
    {_id: '60f4666196d7b3151afffb9b', name: 'Dhubri'},
    {_id: '60f4666196d7b3151afffc06', name: 'Dibrugarh'},
    {_id: '60f4666196d7b3151afffba7', name: 'Dima Hasao'},
    {_id: '60f4666196d7b3151afffc8d', name: 'Goalpara'},
    {_id: '60f4666196d7b3151afffc13', name: 'Golaghat'},
    {_id: '60f4666196d7b3151afffc9a', name: 'Hailakandi'},
    {_id: '60f4666196d7b3151afffd1e', name: 'Hojai'},
    {_id: '60f4666196d7b3151afffc1a', name: 'Jorhat'},
    {_id: '60f4666196d7b3151afffb96', name: 'Kamrup'},
    {_id: '60f4666196d7b3151afffcbc', name: 'Kamrup Metro'},
    {_id: '60f4666196d7b3151afffc9d', name: 'Karbi Anglong'},
    {_id: '60f4666196d7b3151afffb77', name: 'Karimganj'},
    {_id: '60f4666196d7b3151afffbd8', name: 'Kokrajhar'},
    {_id: '60f4666196d7b3151afffbe0', name: 'Lakhimpur'},
    {_id: '60f4666196d7b3151afffccc', name: 'Majuli'},
    {_id: '60f4666196d7b3151afffb86', name: 'Marigaon'},
    {_id: '60f4666196d7b3151afffcde', name: 'Nagaon'},
    {_id: '60f4666196d7b3151afffc6f', name: 'Nalbari'},
    {_id: '60f4666196d7b3151afffcc7', name: 'Sivasagar'},
    {_id: '60f4666196d7b3151afffb9f', name: 'Sonitpur'},
    {
      _id: '60f4666196d7b3151afffd0a',
      name: 'South Salmara Mancachar',
    },
    {_id: '60f4666196d7b3151afffce9', name: 'Tinsukia'},
    {_id: '60f4666196d7b3151afffb79', name: 'Udalguri'},
  ],
  Karnataka: [
    {_id: '60f4666196d7b3151afffcf0', name: 'Bagalkote'},
    {_id: '60f4666196d7b3151afffbad', name: 'Ballari'},
    {_id: '60f4666196d7b3151afffc96', name: 'Belagavi'},
    {_id: '60f4666196d7b3151afffb6b', name: 'Bengaluru'},
    {_id: '60f4666196d7b3151afffc8e', name: 'Bengaluru Rural'},
    {_id: '60f4666196d7b3151afffc3d', name: 'Bengaluru Urban'},
    {_id: '60f4666196d7b3151afffcf7', name: 'Bidar'},
    {_id: '60f4666196d7b3151afffd0e', name: 'Chamarajanagara'},
    {_id: '60f4666196d7b3151afffbf9', name: 'Chikkaballapura'},
    {_id: '60f4666196d7b3151afffce2', name: 'Chikkamagaluru'},
    {_id: '60f4666196d7b3151afffbc9', name: 'Chitradurga'},
    {_id: '60f4666196d7b3151afffcd0', name: 'Dakshina Kannada'},
    {_id: '60f4666196d7b3151afffba0', name: 'Davangere'},
    {_id: '60f4666196d7b3151afffc85', name: 'Dharwad'},
    {_id: '60f4666196d7b3151afffbb2', name: 'Gadag'},
    {_id: '60f4666196d7b3151afffcbb', name: 'Hassan'},
    {_id: '60f4666196d7b3151afffb68', name: 'Haveri'},
    {_id: '60f4666196d7b3151afffc6e', name: 'Kalaburagi'},
    {_id: '60f4666196d7b3151afffd18', name: 'Kodagu'},
    {_id: '60f4666196d7b3151afffc8a', name: 'Kolar'},
    {_id: '60f4666196d7b3151afffd28', name: 'Koppal'},
    {_id: '60f4666196d7b3151afffc60', name: 'Mandya'},
    {_id: '60f4666196d7b3151afffca4', name: 'Mysuru'},
    {_id: '60f4666196d7b3151afffc30', name: 'Raichur'},
    {_id: '60f4666196d7b3151afffd03', name: 'Ramanagara'},
    {_id: '60f4666196d7b3151afffbab', name: 'Shivamogga'},
    {_id: '60f4666196d7b3151afffc59', name: 'Tumakuru'},
    {_id: '60f4666196d7b3151afffbd4', name: 'Udupi'},
    {_id: '60f4666196d7b3151afffc52', name: 'Uttara Kannada'},
    {_id: '60f4666196d7b3151afffcf2', name: 'Vijayapura'},
    {_id: '60f4666196d7b3151afffc86', name: 'Yadgir'},
  ],
  'Tamil Nadu': [
    {_id: '60f4666196d7b3151afffc8f', name: 'Ariyalur'},
    {_id: '60f4666196d7b3151afffcaa', name: 'Chengalpattu'},
    {_id: '60f4666196d7b3151afffb72', name: 'Chennai'},
    {_id: '60f4666196d7b3151afffbb3', name: 'Coimbatore'},
    {_id: '60f4666196d7b3151afffb56', name: 'Cuddalore'},
    {_id: '60f4666196d7b3151afffd11', name: 'Dharmapuri'},
    {_id: '60f4666196d7b3151afffd01', name: 'Dindigul'},
    {_id: '60f4666196d7b3151afffcfa', name: 'Erode'},
    {_id: '60f4666196d7b3151afffc0e', name: 'Kallakurichi'},
    {_id: '60f4666196d7b3151afffca0', name: 'Kanchipuram'},
    {_id: '60f4666196d7b3151afffd0d', name: 'Kanniyakumari'},
    {_id: '60f4666196d7b3151afffd05', name: 'Karur'},
    {_id: '60f4666196d7b3151afffc28', name: 'Krishnagiri'},
    {_id: '60f4666196d7b3151afffc73', name: 'Madurai'},
    {_id: '60f4666196d7b3151afffc83', name: 'Nagapattinam'},
    {_id: '60f4666196d7b3151afffbef', name: 'Namakkal'},
    {_id: '60f4666196d7b3151afffbfe', name: 'Perambalur'},
    {_id: '60f4666196d7b3151afffcbe', name: 'Pudukkottai'},
    {_id: '60f4666196d7b3151afffc66', name: 'Ramanathapuram'},
    {_id: '60f4666196d7b3151afffba6', name: 'Ranipet'},
    {_id: '60f4666196d7b3151afffc8c', name: 'Salem'},
    {_id: '60f4666196d7b3151afffcfe', name: 'Sivaganga'},
    {_id: '60f4666196d7b3151afffc4b', name: 'Tenkasi'},
    {_id: '60f4666196d7b3151afffbbf', name: 'Thanjavur'},
    {_id: '60f4666196d7b3151afffc33', name: 'The Nilgiris'},
    {_id: '60f4666196d7b3151afffca9', name: 'Theni'},
    {_id: '60f4666196d7b3151afffc70', name: 'Thiruvallur'},
    {_id: '60f4666196d7b3151afffcbd', name: 'Thiruvarur'},
    {_id: '60f4666196d7b3151afffba5', name: 'Tiruchirappalli'},
    {_id: '60f4666196d7b3151afffbff', name: 'Tirunelveli'},
    {_id: '60f4666196d7b3151afffcf8', name: 'Tirupathur'},
    {_id: '60f4666196d7b3151afffc7c', name: 'Tiruppur'},
    {_id: '60f4666196d7b3151afffce0', name: 'Tiruvannamalai'},
    {_id: '60f4666196d7b3151afffc36', name: 'Tuticorin'},
    {_id: '60f4666196d7b3151afffd09', name: 'Vellore'},
    {_id: '60f4666196d7b3151afffc65', name: 'Villupuram'},
    {_id: '60f4666196d7b3151afffd27', name: 'Virudhunagar'},
  ],
  Mizoram: [
    {_id: '60f4666196d7b3151afffc04', name: 'Aizawl'},
    {_id: '60f4666196d7b3151afffc9f', name: 'Champhai'},
    {_id: '60f4666196d7b3151afffbae', name: 'Kolasib'},
    {_id: '60f4666196d7b3151afffcd4', name: 'Lawngtlai'},
    {_id: '60f4666196d7b3151afffcf9', name: 'Lunglei'},
    {_id: '60f4666196d7b3151afffc3a', name: 'Mamit'},
    {_id: '60f4666196d7b3151afffb59', name: 'Saiha'},
    {_id: '60f4666196d7b3151afffc26', name: 'Serchhip'},
  ],
  'The Dadra And Nagar Haveli And Daman And Diu': [
    {_id: '60f4666196d7b3151afffc31', name: 'Dadra And Nagar Haveli'},
    {_id: '60f4666196d7b3151afffb82', name: 'Daman'},
    {_id: '60f4666196d7b3151afffc4d', name: 'Diu'},
  ],
  Uttarakhand: [
    {_id: '60f4666196d7b3151afffc72', name: 'Almora'},
    {_id: '60f4666196d7b3151afffca3', name: 'Bageshwar'},
    {_id: '60f4666196d7b3151afffd23', name: 'Chamoli'},
    {_id: '60f4666196d7b3151afffcdc', name: 'Champawat'},
    {_id: '60f4666196d7b3151afffb9a', name: 'Dehradun'},
    {_id: '60f4666196d7b3151afffbdf', name: 'Haridwar'},
    {_id: '60f4666196d7b3151afffbac', name: 'Nainital'},
    {_id: '60f4666196d7b3151afffbb7', name: 'Pauri Garhwal'},
    {_id: '60f4666196d7b3151afffc71', name: 'Pithoragarh'},
    {_id: '60f4666196d7b3151afffd20', name: 'Rudra Prayag'},
    {_id: '60f4666196d7b3151afffb87', name: 'Tehri Garhwal'},
    {_id: '60f4666196d7b3151afffba8', name: 'Udam Singh Nagar'},
    {_id: '60f4666196d7b3151afffcc9', name: 'Uttar Kashi'},
  ],
  Ladakh: [
    {_id: '60f4666196d7b3151afffd31', name: 'Kargil'},
    {_id: '60f4666196d7b3151afffb92', name: 'Leh Ladakh'},
  ],
  'Madhya Pradesh': [
    {_id: '60f4666196d7b3151afffb63', name: 'Agar Malwa'},
    {_id: '60f4666196d7b3151afffcc3', name: 'Alirajpur'},
    {_id: '60f4666196d7b3151afffbc8', name: 'Anuppur'},
    {_id: '60f4666196d7b3151afffb74', name: 'Ashoknagar'},
    {_id: '60f4666196d7b3151afffb6d', name: 'Balaghat'},
    {_id: '60f4666196d7b3151afffc10', name: 'Barwani'},
    {_id: '60f4666196d7b3151afffcae', name: 'Betul'},
    {_id: '60f4666196d7b3151afffbb8', name: 'Bhind'},
    {_id: '60f4666196d7b3151afffd1a', name: 'Bhopal'},
    {_id: '60f4666196d7b3151afffba2', name: 'Burhanpur'},
    {_id: '60f4666196d7b3151afffc53', name: 'Chhatarpur'},
    {_id: '60f4666196d7b3151afffd1b', name: 'Chhindwara'},
    {_id: '60f4666196d7b3151afffc98', name: 'Damoh'},
    {_id: '60f4666196d7b3151afffc3f', name: 'Datia'},
    {_id: '60f4666196d7b3151afffd26', name: 'Dewas'},
    {_id: '60f4666196d7b3151afffc2a', name: 'Dhar'},
    {_id: '60f4666196d7b3151afffd2c', name: 'Dindori'},
    {_id: '60f4666196d7b3151afffbcf', name: 'East Nimar'},
    {_id: '60f4666196d7b3151afffbb9', name: 'Guna'},
    {_id: '60f4666196d7b3151afffd1f', name: 'Gwalior'},
    {_id: '60f4666196d7b3151afffbe8', name: 'Harda'},
    {_id: '60f4666196d7b3151afffb78', name: 'Hoshangabad'},
    {_id: '60f4666196d7b3151afffce4', name: 'Indore'},
    {_id: '60f4666196d7b3151afffbdc', name: 'Jabalpur'},
    {_id: '60f4666196d7b3151afffc7d', name: 'Jhabua'},
    {_id: '60f4666196d7b3151afffc9e', name: 'Katni'},
    {_id: '60f4666196d7b3151afffccf', name: 'Khargone'},
    {_id: '60f4666196d7b3151afffcac', name: 'Mandla'},
    {_id: '60f4666196d7b3151afffbaf', name: 'Mandsaur'},
    {_id: '60f4666196d7b3151afffbfa', name: 'Morena'},
    {_id: '60f4666196d7b3151afffc7e', name: 'Narsinghpur'},
    {_id: '60f4666196d7b3151afffba4', name: 'Neemuch'},
    {_id: '60f4666196d7b3151afffbfb', name: 'Panna'},
    {_id: '60f4666196d7b3151afffc6a', name: 'Raisen'},
    {_id: '60f4666196d7b3151afffcc8', name: 'Rajgarh'},
    {_id: '60f4666196d7b3151afffc5b', name: 'Ratlam'},
    {_id: '60f4666196d7b3151afffb9c', name: 'Rewa'},
    {_id: '60f4666196d7b3151afffc29', name: 'Sagar'},
    {_id: '60f4666196d7b3151afffd17', name: 'Satna'},
    {_id: '60f4666196d7b3151afffcd9', name: 'Sehore'},
    {_id: '60f4666196d7b3151afffcba', name: 'Seoni'},
    {_id: '60f4666196d7b3151afffc82', name: 'Shahdol'},
    {_id: '60f4666196d7b3151afffbe3', name: 'Shajapur'},
    {_id: '60f4666196d7b3151afffc63', name: 'Sheopur'},
    {_id: '60f4666196d7b3151afffb7e', name: 'Shivpuri'},
    {_id: '60f4666196d7b3151afffbce', name: 'Sidhi'},
    {_id: '60f4666196d7b3151afffc91', name: 'Singrauli'},
    {_id: '60f4666196d7b3151afffd0b', name: 'Tikamgarh'},
    {_id: '60f4666196d7b3151afffcc5', name: 'Ujjain'},
    {_id: '60f4666196d7b3151afffb67', name: 'Umaria'},
    {_id: '60f4666196d7b3151afffbf4', name: 'Vidisha'},
  ],
  Rajasthan: [
    {_id: '60f4666196d7b3151afffd39', name: 'Ajmer'},
    {_id: '60f4666196d7b3151afffb94', name: 'Alwar'},
    {_id: '60f4666196d7b3151afffbec', name: 'Banswara'},
    {_id: '60f4666196d7b3151afffbf6', name: 'Baran'},
    {_id: '60f4666196d7b3151afffb8e', name: 'Barmer'},
    {_id: '60f4666196d7b3151afffc35', name: 'Bharatpur'},
    {_id: '60f4666196d7b3151afffc3b', name: 'Bhilwara'},
    {_id: '60f4666196d7b3151afffd1c', name: 'Bikaner'},
    {_id: '60f4666196d7b3151afffce3', name: 'Bundi'},
    {_id: '60f4666196d7b3151afffcb0', name: 'Chittorgarh'},
    {_id: '60f4666196d7b3151afffc15', name: 'Churu'},
    {_id: '60f4666196d7b3151afffbbd', name: 'Dausa'},
    {_id: '60f4666196d7b3151afffc56', name: 'Dholpur'},
    {_id: '60f4666196d7b3151afffccd', name: 'Dungarpur'},
    {_id: '60f4666196d7b3151afffc42', name: 'Ganganagar'},
    {_id: '60f4666196d7b3151afffbde', name: 'Hanumangarh'},
    {_id: '60f4666196d7b3151afffc67', name: 'Jaipur'},
    {_id: '60f4666196d7b3151afffcd5', name: 'Jaisalmer'},
    {_id: '60f4666196d7b3151afffc46', name: 'Jalore'},
    {_id: '60f4666196d7b3151afffbd0', name: 'Jhalawar'},
    {_id: '60f4666196d7b3151afffca6', name: 'Jhunjhunu'},
    {_id: '60f4666196d7b3151afffba3', name: 'Jodhpur'},
    {_id: '60f4666196d7b3151afffc87', name: 'Karauli'},
    {_id: '60f4666196d7b3151afffbf0', name: 'Kota'},
    {_id: '60f4666196d7b3151afffc23', name: 'Nagaur'},
    {_id: '60f4666196d7b3151afffbc3', name: 'Pali'},
    {_id: '60f4666196d7b3151afffc69', name: 'Pratapgarh'},
    {_id: '60f4666196d7b3151afffb75', name: 'Rajsamand'},
    {_id: '60f4666196d7b3151afffc4f', name: 'Sawai Madhopur'},
    {_id: '60f4666196d7b3151afffc97', name: 'Sikar'},
    {_id: '60f4666196d7b3151afffcfb', name: 'Sirohi'},
    {_id: '60f4666196d7b3151afffbf8', name: 'Tonk'},
    {_id: '60f4666196d7b3151afffc38', name: 'Udaipur'},
  ],
  Puducherry: [
    {_id: '60f4666196d7b3151afffbd3', name: 'Karaikal'},
    {_id: '60f4666196d7b3151afffb98', name: 'Mahe'},
    {_id: '60f4666196d7b3151afffb93', name: 'Pondicherry'},
    {_id: '60f4666196d7b3151afffc75', name: 'Yanam'},
  ],
  Goa: [
    {_id: '60f4666196d7b3151afffcdf', name: 'Goa'},
    {_id: '60f4666196d7b3151afffc6d', name: 'North Goa'},
    {_id: '60f4666196d7b3151afffca7', name: 'South Goa'},
  ],
  Telangana: [
    {_id: '5dce8d42ecd44f1980cefe20', name: 'Adilabad'},
    {_id: '5dce8d42ecd44f1980cefe2a', name: 'Bhadradri Kothagudem'},
    {_id: '5dce8d42ecd44f1980cefe21', name: 'Hyderabad'},
    {_id: '5dce8d42ecd44f1980cefe2b', name: 'Jagitial'},
    {_id: '5dce8d42ecd44f1980cefe2c', name: 'Jangaon'},
    {
      _id: '5dce8d42ecd44f1980cefe2d',
      name: 'Jayashankar Bhupalapally',
    },
    {_id: '5dce8d42ecd44f1980cefe2e', name: 'Jogulamba Gadwal'},
    {_id: '5dce8d42ecd44f1980cefe2f', name: 'Kamareddy'},
    {_id: '5dce8d42ecd44f1980cefe22', name: 'Karimnagar'},
    {_id: '5dce8d42ecd44f1980cefe23', name: 'Khammam'},
    {_id: '5dce8d42ecd44f1980cefe30', name: 'Kumuram Bheem Asifabad'},
    {_id: '5dce8d42ecd44f1980cefe31', name: 'Mahabubabad'},
    {_id: '5dce8d42ecd44f1980cefe24', name: 'Mahbubnagar'},
    {_id: '5dce8d42ecd44f1980cefe25', name: 'Medak'},
    {_id: '5dce8d42ecd44f1980cefe32', name: 'Medchal'},
    {_id: '5dce8d42ecd44f1980cefe33', name: 'Mulugu'},
    {_id: '5dce8d42ecd44f1980cefe34', name: 'Nagarkurnool'},
    {_id: '5dce8d42ecd44f1980cefe26', name: 'Nalgonda'},
    {_id: '5dce8d42ecd44f1980cefe35', name: 'Narayanpet'},
    {_id: '5dce8d42ecd44f1980cefe36', name: 'Nirmal'},
    {_id: '5dce8d42ecd44f1980cefe27', name: 'Nizamabad'},
    {_id: '5dce8d42ecd44f1980cefe37', name: 'Peddapalli'},
    {_id: '5dce8d42ecd44f1980cefe38', name: 'Rajanna Sircilla'},
    {_id: '5dce8d42ecd44f1980cefe28', name: 'Rangareddy'},
    {_id: '5dce8d42ecd44f1980cefe39', name: 'Sangareddy'},
    {_id: '5dce8d42ecd44f1980cefe3a', name: 'Siddipet'},
    {_id: '5dce8d42ecd44f1980cefe3b', name: 'Suryapet'},
    {_id: '5dce8d42ecd44f1980cefe3c', name: 'Vikarabad'},
    {_id: '5dce8d42ecd44f1980cefe3d', name: 'Wanaparthy'},
    {_id: '5dce8d42ecd44f1980cefe29', name: 'Warangal'},
    {_id: '5dce8d42ecd44f1980cefe3e', name: 'Warangal Rural'},
    {_id: '5dce8d42ecd44f1980cefe3f', name: 'Warangal Urban'},
    {_id: '5dce8d42ecd44f1980cefe40', name: 'Yadadri Bhuvanagiri'},
  ],
  Maharashtra: [
    {_id: '60142c57237cfbe0e3a78f4f', name: 'Ahmednagar'},
    {_id: '60142bcb237cfbe0e3a78f12', name: 'Akola'},
    {_id: '60142bcb237cfbe0e3a78f13', name: 'Amravati'},
    {_id: '60142c57237cfbe0e3a78f36', name: 'Aurangabad'},
    {_id: '60142c57237cfbe0e3a78f37', name: 'Beed'},
    {_id: '60142c57237cfbe0e3a78f45', name: 'Bhandara'},
    {_id: '60142bcb237cfbe0e3a78f14', name: 'Buldana'},
    {_id: '60142c57237cfbe0e3a78f46', name: 'Chandrapur'},
    {_id: '60142c57237cfbe0e3a78f4b', name: 'Dhule'},
    {_id: '60142c57237cfbe0e3a78f47', name: 'Gadchiroli'},
    {_id: '60142c57237cfbe0e3a78f48', name: 'Gondia'},
    {_id: '60142c57237cfbe0e3a78f3d', name: 'Hingoli'},
    {_id: '60142c57237cfbe0e3a78f4c', name: 'Jalgaon'},
    {_id: '60142c57237cfbe0e3a78f38', name: 'Jalna'},
    {_id: '60142c57237cfbe0e3a78f50', name: 'Kolhapur'},
    {_id: '60142c57237cfbe0e3a78f3b', name: 'Latur'},
    {_id: '60142c57237cfbe0e3a78f3e', name: 'Mumbai City'},
    {_id: '60142c57237cfbe0e3a78f3f', name: 'Mumbai Suburban'},
    {_id: '60142c57237cfbe0e3a78f49', name: 'Nagpur'},
    {_id: '60142c57237cfbe0e3a78f3a', name: 'Nanded'},
    {_id: '60142c57237cfbe0e3a78f4d', name: 'Nandurbar'},
    {_id: '60142c57237cfbe0e3a78f4e', name: 'Nashik'},
    {_id: '60142c57237cfbe0e3a78f39', name: 'Osmanabad'},
    {_id: '60142c57237cfbe0e3a78f41', name: 'Palghar'},
    {_id: '60142c57237cfbe0e3a78f3c', name: 'Parbhani'},
    {_id: '60142c57237cfbe0e3a78f51', name: 'Pune'},
    {_id: '60142c57237cfbe0e3a78f42', name: 'Raigad'},
    {_id: '60142c57237cfbe0e3a78f43', name: 'Ratnagiri'},
    {_id: '60142c57237cfbe0e3a78f52', name: 'Sangli'},
    {_id: '60142c57237cfbe0e3a78f53', name: 'Satara'},
    {_id: '60142c57237cfbe0e3a78f44', name: 'Sindhudurg'},
    {_id: '60142c57237cfbe0e3a78f54', name: 'Solapur'},
    {_id: '60142c57237cfbe0e3a78f40', name: 'Thane'},
    {_id: '60142c57237cfbe0e3a78f4a', name: 'Wardha'},
    {_id: '60142bcb237cfbe0e3a78f16', name: 'Washim'},
    {_id: '60142bcb237cfbe0e3a78f15', name: 'Yavatmal'},
  ],
  Nagaland: [
    {_id: '60f4666196d7b3151afffc17', name: 'Dimapur'},
    {_id: '60f4666196d7b3151afffc50', name: 'Kiphire'},
    {_id: '60f4666196d7b3151afffc9b', name: 'Kohima'},
    {_id: '60f4666196d7b3151afffbbc', name: 'Longleng'},
    {_id: '60f4666196d7b3151afffc8b', name: 'Mokokchung'},
    {_id: '60f4666196d7b3151afffd06', name: 'Mon'},
    {_id: '60f4666196d7b3151afffbb0', name: 'Peren'},
    {_id: '60f4666196d7b3151afffce1', name: 'Phek'},
    {_id: '60f4666196d7b3151afffc61', name: 'Tuensang'},
    {_id: '60f4666196d7b3151afffb5f', name: 'Wokha'},
    {_id: '60f4666196d7b3151afffd19', name: 'Zunheboto'},
  ],
  Kerala: [
    {_id: '60f4666196d7b3151afffc3e', name: 'Alappuzha'},
    {_id: '60f4666196d7b3151afffb89', name: 'Ernakulam'},
    {_id: '60f4666196d7b3151afffc2f', name: 'Idukki'},
    {_id: '60f4666196d7b3151afffc0d', name: 'Kannur'},
    {_id: '60f4666196d7b3151afffd14', name: 'Kasaragod'},
    {_id: '60f4666196d7b3151afffce7', name: 'Kollam'},
    {_id: '60f4666196d7b3151afffbed', name: 'Kottayam'},
    {_id: '60f4666196d7b3151afffcff', name: 'Kozhikode'},
    {_id: '60f4666196d7b3151afffd0c', name: 'Malappuram'},
    {_id: '60f4666196d7b3151afffb57', name: 'Palakkad'},
    {_id: '60f4666196d7b3151afffd3b', name: 'Pathanamthitta'},
    {_id: '60f4666196d7b3151afffc80', name: 'Thiruvananthapuram'},
    {_id: '60f4666196d7b3151afffc1f', name: 'Thrissur'},
    {_id: '60f4666196d7b3151afffc7f', name: 'Wayanad'},
  ],
  Jharkhand: [
    {_id: '5dce8d42ecd44f1980cefe08', name: 'Bokaro'},
    {_id: '5dce8d42ecd44f1980cefe09', name: 'Chatra'},
    {_id: '5dce8d42ecd44f1980cefe0a', name: 'Deoghar'},
    {_id: '5dce8d42ecd44f1980cefe0b', name: 'Dhanbad'},
    {_id: '5dce8d42ecd44f1980cefe0c', name: 'Dumka'},
    {_id: '5dce8d42ecd44f1980cefe1a', name: 'East Singhbhum'},
    {_id: '5dce8d42ecd44f1980cefe0d', name: 'Garhwa'},
    {_id: '5dce8d42ecd44f1980cefe0e', name: 'Giridih'},
    {_id: '5dce8d42ecd44f1980cefe0f', name: 'Godda'},
    {_id: '5dce8d42ecd44f1980cefe10', name: 'Gumla'},
    {_id: '5dce8d42ecd44f1980cefe11', name: 'Hazaribagh'},
    {_id: '5dce8d42ecd44f1980cefe12', name: 'Jamtara'},
    {_id: '5dce8d42ecd44f1980cefe13', name: 'Khunti'},
    {_id: '5dce8d42ecd44f1980cefe14', name: 'Koderma'},
    {_id: '5dce8d42ecd44f1980cefe15', name: 'Latehar'},
    {_id: '5dce8d42ecd44f1980cefe16', name: 'Lohardaga'},
    {_id: '5dce8d42ecd44f1980cefe17', name: 'Pakur'},
    {_id: '5dce8d42ecd44f1980cefe18', name: 'Palamu'},
    {_id: '5dce8d42ecd44f1980cefe1b', name: 'Ramgarh'},
    {_id: '5dce8d42ecd44f1980cefe1c', name: 'Ranchi'},
    {_id: '5dce8d42ecd44f1980cefe1d', name: 'Sahibganj'},
    {_id: '5dce8d42ecd44f1980cefe1e', name: 'Seraikela-Kharsawan'},
    {_id: '5dce8d42ecd44f1980cefe1f', name: 'Simdega'},
    {_id: '5dce8d42ecd44f1980cefe19', name: 'West Singhbhum'},
  ],
  'Arunachal Pradesh': [
    {_id: '60f4666196d7b3151afffc51', name: 'Anjaw'},
    {_id: '60f4666196d7b3151afffca5', name: 'Changlang'},
    {_id: '60f4666196d7b3151afffc1e', name: 'Dibang Valley'},
    {_id: '60f4666196d7b3151afffcdd', name: 'East Kameng'},
    {_id: '60f4666196d7b3151afffc25', name: 'East Siang'},
    {_id: '60f4666196d7b3151afffc05', name: 'Kurung Kumey'},
    {_id: '60f4666196d7b3151afffbe4', name: 'Lohit'},
    {_id: '60f4666196d7b3151afffbb6', name: 'Longding'},
    {_id: '60f4666196d7b3151afffc2d', name: 'Lower Dibang Valley'},
    {_id: '60f4666196d7b3151afffb55', name: 'Lower Subansiri'},
    {_id: '60f4666196d7b3151afffbe9', name: 'Papum Pare'},
    {_id: '60f4666196d7b3151afffc62', name: 'Tawang'},
    {_id: '60f4666196d7b3151afffb58', name: 'Tirap'},
    {_id: '60f4666196d7b3151afffc3c', name: 'Upper Siang'},
    {_id: '60f4666196d7b3151afffc92', name: 'Upper Subansiri'},
    {_id: '60f4666196d7b3151afffd3a', name: 'West Kameng'},
    {_id: '60f4666196d7b3151afffcc6', name: 'West Siang'},
  ],
  Manipur: [
    {_id: '60f4666196d7b3151afffcab', name: 'Bishnupur'},
    {_id: '60f4666196d7b3151afffc95', name: 'Chandel'},
    {_id: '60f4666196d7b3151afffb80', name: 'Churachandpur'},
    {_id: '60f4666196d7b3151afffcc1', name: 'Imphal East'},
    {_id: '60f4666196d7b3151afffbea', name: 'Imphal West'},
    {_id: '60f4666196d7b3151afffc0f', name: 'Kakching'},
    {_id: '60f4666196d7b3151afffc39', name: 'Kamjong'},
    {_id: '60f4666196d7b3151afffc03', name: 'Noney'},
    {_id: '60f4666196d7b3151afffc41', name: 'Senapati'},
    {_id: '60f4666196d7b3151afffbbb', name: 'Tamenglong'},
    {_id: '60f4666196d7b3151afffb70', name: 'Tengnoupal'},
    {_id: '60f4666196d7b3151afffc40', name: 'Thoubal'},
    {_id: '60f4666196d7b3151afffd38', name: 'Ukhrul'},
  ],
  Tripura: [
    {_id: '60f4666196d7b3151afffc14', name: 'Dhalai'},
    {_id: '60f4666196d7b3151afffc00', name: 'Gomati'},
    {_id: '60f4666196d7b3151afffd33', name: 'Khowai'},
    {_id: '60f4666196d7b3151afffbeb', name: 'North Tripura'},
    {_id: '60f4666196d7b3151afffb8a', name: 'Sepahijala'},
    {_id: '60f4666196d7b3151afffb8d', name: 'South Tripura'},
    {_id: '60f4666196d7b3151afffc79', name: 'Unakoti'},
    {_id: '60f4666196d7b3151afffba9', name: 'West Tripura'},
  ],
  Sikkim: [
    {_id: '60f4666196d7b3151afffc22', name: 'East District'},
    {_id: '60f4666196d7b3151afffc6b', name: 'North District'},
    {_id: '60f4666196d7b3151afffcb3', name: 'South District'},
    {_id: '60f4666196d7b3151afffcef', name: 'West District'},
  ],
  Valsad: [{_id: '60f4666196d7b3151afffcd2', name: 'NEAR DEHRI'}],
  Odisha: [
    {_id: '5dce8d43ecd44f1980ceff37', name: 'Anugul'},
    {_id: '5dce8d43ecd44f1980ceff38', name: 'Balangir'},
    {_id: '5dce8d43ecd44f1980ceff39', name: 'Baleshwar'},
    {_id: '5dce8d43ecd44f1980ceff3a', name: 'Bargarh'},
    {_id: '5dce8d43ecd44f1980ceff3b', name: 'Baudh'},
    {_id: '5dce8d43ecd44f1980ceff3c', name: 'Bhadrak'},
    {_id: '5dce8d43ecd44f1980ceff3d', name: 'Cuttack'},
    {_id: '5dce8d43ecd44f1980ceff3e', name: 'Debagarh'},
    {_id: '5dce8d43ecd44f1980ceff3f', name: 'Dhenkanal'},
    {_id: '5dce8d43ecd44f1980ceff40', name: 'Gajapati'},
    {_id: '5dce8d43ecd44f1980ceff41', name: 'Ganjam'},
    {_id: '5dce8d43ecd44f1980ceff42', name: 'Jagatsinghpur'},
    {_id: '5dce8d43ecd44f1980ceff43', name: 'Jajapur'},
    {_id: '5dce8d43ecd44f1980ceff44', name: 'Jharsuguda'},
    {_id: '5dce8d43ecd44f1980ceff45', name: 'Kalahandi'},
    {_id: '5dce8d43ecd44f1980ceff46', name: 'Kandhamal'},
    {_id: '5dce8d43ecd44f1980ceff47', name: 'Kendrapara'},
    {_id: '5dce8d43ecd44f1980ceff48', name: 'Kendujhar'},
    {_id: '5dce8d43ecd44f1980ceff49', name: 'Khordha'},
    {_id: '5dce8d43ecd44f1980ceff4a', name: 'Koraput'},
    {_id: '5dce8d43ecd44f1980ceff4b', name: 'Malkangiri'},
    {_id: '5dce8d43ecd44f1980ceff4c', name: 'Mayurbhanj'},
    {_id: '5dce8d43ecd44f1980ceff4d', name: 'Nabarangapur'},
    {_id: '5dce8d43ecd44f1980ceff4e', name: 'Nayagarh'},
    {_id: '5dce8d43ecd44f1980ceff4f', name: 'Nuapada'},
    {_id: '5dce8d43ecd44f1980ceff50', name: 'Puri'},
    {_id: '5dce8d43ecd44f1980ceff51', name: 'Rayagada'},
    {_id: '5dce8d43ecd44f1980ceff52', name: 'Sambalpur'},
    {_id: '5dce8d43ecd44f1980ceff53', name: 'Subarnapur'},
    {_id: '5dce8d43ecd44f1980ceff54', name: 'Sundargarh'},
  ],
  'Himachal Pradesh': [
    {_id: '60f4666196d7b3151afffc49', name: 'Chamba'},
    {_id: '60f4666196d7b3151afffd13', name: 'Garhwal'},
    {_id: '60f4666196d7b3151afffc54', name: 'Hamirpur'},
    {_id: '60f4666196d7b3151afffcb2', name: 'Kangra'},
    {_id: '60f4666196d7b3151afffcd8', name: 'Kinnaur'},
    {_id: '60f4666196d7b3151afffb8c', name: 'Kullu'},
    {_id: '60f4666196d7b3151afffbcb', name: 'Lahul And Spiti'},
    {_id: '60f4666196d7b3151afffc57', name: 'Mandi'},
    {_id: '60f4666196d7b3151afffc19', name: 'Shimla'},
    {_id: '60f4666196d7b3151afffb69', name: 'Sirmaur'},
    {_id: '60f4666196d7b3151afffcbf', name: 'Solan'},
    {_id: '60f4666196d7b3151afffcce', name: 'Una'},
  ],
  'Jammu And Kashmir': [
    {_id: '60f4666196d7b3151afffc77', name: 'Anantnag'},
    {_id: '60f4666196d7b3151afffbca', name: 'Bandipora'},
    {_id: '60f4666196d7b3151afffbc0', name: 'Baramulla'},
    {_id: '60f4666196d7b3151afffb6a', name: 'Budgam'},
    {_id: '60f4666196d7b3151afffc55', name: 'Doda'},
    {_id: '60f4666196d7b3151afffc81', name: 'Ganderbal'},
    {_id: '60f4666196d7b3151afffcf1', name: 'Jammu'},
    {_id: '60f4666196d7b3151afffc34', name: 'Kathua'},
    {_id: '60f4666196d7b3151afffcf4', name: 'Kishtwar'},
    {_id: '60f4666196d7b3151afffc45', name: 'Kulgam'},
    {_id: '60f4666196d7b3151afffb6f', name: 'Kupwara'},
    {_id: '60f4666196d7b3151afffb83', name: 'Poonch'},
    {_id: '60f4666196d7b3151afffd36', name: 'Pulwama'},
    {_id: '60f4666196d7b3151afffc47', name: 'Rajouri'},
    {_id: '60f4666196d7b3151afffb7f', name: 'Ramban'},
    {_id: '60f4666196d7b3151afffbd9', name: 'Reasi'},
    {_id: '60f4666196d7b3151afffcd3', name: 'Samba'},
    {_id: '60f4666196d7b3151afffb66', name: 'Shopian'},
    {_id: '60f4666196d7b3151afffb8f', name: 'Srinagar'},
    {_id: '60f4666196d7b3151afffd2a', name: 'Udhampur'},
  ],
  Chhattisgarh: [
    {_id: '60f4666196d7b3151afffbf7', name: 'Balod'},
    {_id: '60f4666196d7b3151afffc01', name: 'Baloda Bazar'},
    {_id: '60f4666196d7b3151afffcca', name: 'Balrampur'},
    {_id: '60f4666196d7b3151afffbf3', name: 'Bastar'},
    {_id: '60f4666196d7b3151afffd2e', name: 'Bemetara'},
    {_id: '60f4666196d7b3151afffb95', name: 'Bijapur'},
    {_id: '60f4666196d7b3151afffd0f', name: 'Bilaspur'},
    {_id: '60f4666196d7b3151afffbd7', name: 'Dantewada'},
    {_id: '60f4666196d7b3151afffb97', name: 'Dhamtari'},
    {_id: '60f4666196d7b3151afffc21', name: 'Durg'},
    {_id: '60f4666196d7b3151afffc18', name: 'Gariyaband'},
    {_id: '60f4666196d7b3151afffbee', name: 'Janjgir-Champa'},
    {_id: '60f4666196d7b3151afffb6e', name: 'Jashpur'},
    {_id: '60f4666196d7b3151afffd35', name: 'Kabirdham'},
    {_id: '60f4666196d7b3151afffbdd', name: 'Kanker'},
    {_id: '60f4666196d7b3151afffcc4', name: 'Kondagaon'},
    {_id: '60f4666196d7b3151afffcf3', name: 'Korba'},
    {_id: '60f4666196d7b3151afffb88', name: 'Korea'},
    {_id: '60f4666196d7b3151afffd08', name: 'Mahasamund'},
    {_id: '60f4666196d7b3151afffbd1', name: 'Mungeli'},
    {_id: '60f4666196d7b3151afffc37', name: 'Narayanpur'},
    {_id: '60f4666196d7b3151afffbc4', name: 'Raigarh'},
    {_id: '60f4666196d7b3151afffbd6', name: 'Raipur'},
    {_id: '60f4666196d7b3151afffb81', name: 'Rajnandgaon'},
    {_id: '60f4666196d7b3151afffba1', name: 'Sukma'},
    {_id: '60f4666196d7b3151afffb5b', name: 'Surajpur'},
    {_id: '60f4666196d7b3151afffcd7', name: 'Surguja'},
  ],
  'West Bengal': [
    {_id: '60f4666196d7b3151afffc90', name: 'Alipurduar'},
    {_id: '60f4666196d7b3151afffc27', name: 'Bankura'},
    {_id: '60f4666196d7b3151afffb5c', name: 'Bardhaman'},
    {_id: '60f4666196d7b3151afffcda', name: 'Birbhum'},
    {_id: '60f4666196d7b3151afffbb5', name: 'Coochbehar'},
    {_id: '60f4666196d7b3151afffc4a', name: 'Darjeeling'},
    {_id: '60f4666196d7b3151afffcb4', name: 'Dinajpur Dakshin'},
    {_id: '60f4666196d7b3151afffbe5', name: 'Dinajpur Uttar'},
    {_id: '60f4666196d7b3151afffc7b', name: 'Hooghly'},
    {_id: '60f4666196d7b3151afffbc1', name: 'Howrah'},
    {_id: '60f4666196d7b3151afffbb1', name: 'Jalpaiguri'},
    {_id: '60f4666196d7b3151afffd32', name: 'Jhargram'},
    {_id: '60f4666196d7b3151afffb76', name: 'Kalimpong'},
    {_id: '60f4666196d7b3151afffc84', name: 'Kolkata'},
    {_id: '60f4666196d7b3151afffb62', name: 'Maldah'},
    {_id: '60f4666196d7b3151afffbe2', name: 'Medinipur East'},
    {_id: '60f4666196d7b3151afffbcc', name: 'Medinipur West'},
    {_id: '60f4666196d7b3151afffbda', name: 'Murshidabad'},
    {_id: '60f4666196d7b3151afffd34', name: 'Nadia'},
    {_id: '60f4666196d7b3151afffbfd', name: 'Paraganas North'},
    {_id: '60f4666196d7b3151afffb65', name: 'Paraganas South'},
    {_id: '60f4666196d7b3151afffd1d', name: 'Paschim Bardhaman'},
    {_id: '60f4666196d7b3151afffc64', name: 'Purba Bardhaman'},
    {_id: '60f4666196d7b3151afffc5f', name: 'Purulia'},
  ],
  'Andaman And Nicobar Islands': [
    {_id: '60f4666196d7b3151afffced', name: 'Nicobars'},
    {
      _id: '60f4666196d7b3151afffc43',
      name: 'North And Middle Andaman',
    },
    {_id: '60f4666196d7b3151afffb91', name: 'South Andamans'},
  ],
  Pune: [{_id: '60f4666196d7b3151afffc5d', name: 'PUNE'}],
  Delhi: [
    {_id: '60f4666196d7b3151afffcb1', name: 'Central Delhi'},
    {_id: '60f4666196d7b3151afffcec', name: 'East Delhi'},
    {_id: '60f4666196d7b3151afffc6c', name: 'New Delhi'},
    {_id: '60f4666196d7b3151afffbcd', name: 'North Delhi'},
    {_id: '60f4666196d7b3151afffb5a', name: 'North East Delhi'},
    {_id: '60f4666196d7b3151afffc78', name: 'North West Delhi'},
    {_id: '60f4666196d7b3151afffd2d', name: 'Shahdara'},
    {_id: '60f4666196d7b3151afffcd1', name: 'South Delhi'},
    {_id: '60f4666196d7b3151afffb7a', name: 'South East Delhi'},
    {_id: '60f4666196d7b3151afffca1', name: 'South West Delhi'},
    {_id: '60f4666196d7b3151afffc2c', name: 'West Delhi'},
  ],
  Haryana: [
    {_id: '60f4666196d7b3151afffb90', name: 'Ambala'},
    {_id: '60f4666196d7b3151afffc89', name: 'Bhiwani'},
    {_id: '60f4666196d7b3151afffbbe', name: 'Charki Dadri'},
    {_id: '60f4666196d7b3151afffcc0', name: 'Faridabad'},
    {_id: '60f4666196d7b3151afffcfc', name: 'Fatehabad'},
    {_id: '60f4666196d7b3151afffc44', name: 'Gurugram'},
    {_id: '60f4666196d7b3151afffc11', name: 'Hisar'},
    {_id: '60f4666196d7b3151afffc32', name: 'Jhajjar'},
    {_id: '60f4666196d7b3151afffbd2', name: 'Jind'},
    {_id: '60f4666196d7b3151afffcb5', name: 'Kaithal'},
    {_id: '60f4666196d7b3151afffb7d', name: 'Karnal'},
    {_id: '60f4666196d7b3151afffcf5', name: 'Kurukshetra'},
    {_id: '60f4666196d7b3151afffc24', name: 'Mahendragarh'},
    {_id: '60f4666196d7b3151afffb6c', name: 'Nuh'},
    {_id: '60f4666196d7b3151afffbaa', name: 'Palwal'},
    {_id: '60f4666196d7b3151afffcdb', name: 'Panchkula'},
    {_id: '60f4666196d7b3151afffc93', name: 'Panipat'},
    {_id: '60f4666196d7b3151afffb84', name: 'Rewari'},
    {_id: '60f4666196d7b3151afffc74', name: 'Rohtak'},
    {_id: '60f4666196d7b3151afffc1c', name: 'Sirsa'},
    {_id: '60f4666196d7b3151afffca2', name: 'Sonipat'},
    {_id: '60f4666196d7b3151afffcf6', name: 'Yamunanagar'},
  ],
  'Uttar Pradesh': [
    {_id: '5dce8d43ecd44f1980cefff9', name: 'Agra'},
    {_id: '5dce8d43ecd44f1980cefffa', name: 'Aligarh'},
    {_id: '5dce8d43ecd44f1980cefffc', name: 'Ambedkar Nagar'},
    {_id: '5dd4e16bba02ad50c686b951', name: 'Amethi'},
    {_id: '5dce8d43ecd44f1980cefffd', name: 'Amroha'},
    {_id: '5dce8d43ecd44f1980cefffe', name: 'Auraiya'},
    {_id: '5dce8d43ecd44f1980ceffff', name: 'Azamgarh'},
    {_id: '5dce8d43ecd44f1980cf0000', name: 'Baghpat'},
    {_id: '5dce8d43ecd44f1980cf0001', name: 'Bahraich'},
    {_id: '5dce8d43ecd44f1980cf0002', name: 'Ballia'},
    {_id: '5dce8d43ecd44f1980cf0003', name: 'Balrampur'},
    {_id: '5dce8d43ecd44f1980cf0004', name: 'Banda'},
    {_id: '5dce8d43ecd44f1980cf0005', name: 'Bara Banki'},
    {_id: '5dce8d43ecd44f1980cf0006', name: 'Bareilly'},
    {_id: '5dce8d43ecd44f1980cf0007', name: 'Basti'},
    {_id: '5dce8d43ecd44f1980cf0008', name: 'Bijnor'},
    {_id: '5dce8d43ecd44f1980cf0009', name: 'Budaun'},
    {_id: '5dce8d43ecd44f1980cf000a', name: 'Bulandshahr'},
    {_id: '5dce8d43ecd44f1980cf000b', name: 'Chandauli'},
    {_id: '5dce8d43ecd44f1980cf000c', name: 'Chitrakoot'},
    {_id: '5dce8d43ecd44f1980cf000d', name: 'Deoria'},
    {_id: '5dce8d43ecd44f1980cf000e', name: 'Etah'},
    {_id: '5dce8d43ecd44f1980cf000f', name: 'Etawah'},
    {_id: '5dce8d43ecd44f1980cf0010', name: 'Faizabad'},
    {_id: '5dce8d43ecd44f1980cf0011', name: 'Farrukhabad'},
    {_id: '5dce8d43ecd44f1980cf0012', name: 'Fatehpur'},
    {_id: '5dce8d43ecd44f1980cf0013', name: 'Firozabad'},
    {_id: '5dce8d43ecd44f1980cf0014', name: 'Gautam Buddha Nagar'},
    {_id: '5dce8d43ecd44f1980cf0015', name: 'Ghaziabad'},
    {_id: '5dce8d43ecd44f1980cf0016', name: 'Ghazipur'},
    {_id: '5dce8d43ecd44f1980cf0017', name: 'Gonda'},
    {_id: '5dce8d43ecd44f1980cf0018', name: 'Gorakhpur'},
    {_id: '5dce8d43ecd44f1980cf0019', name: 'Hamirpur'},
    {_id: '5dfca1ab964104bdf8043731', name: 'Hapur'},
    {_id: '5dce8d43ecd44f1980cf001a', name: 'Hardoi'},
    {_id: '5dce8d43ecd44f1980cf001b', name: 'Hathras'},
    {_id: '5dce8d43ecd44f1980cf001c', name: 'Jalaun'},
    {_id: '5dce8d43ecd44f1980cf001d', name: 'Jaunpur'},
    {_id: '5dce8d43ecd44f1980cf001e', name: 'Jhansi'},
    {_id: '5dce8d43ecd44f1980cf001f', name: 'Kannauj'},
    {_id: '5dce8d43ecd44f1980cf0020', name: 'Kanpur Dehat'},
    {_id: '5dce8d43ecd44f1980cf0021', name: 'Kanpur Nagar'},
    {_id: '5dce8d43ecd44f1980cf0022', name: 'Kasganj'},
    {_id: '5dce8d43ecd44f1980cf0023', name: 'Kaushambi'},
    {_id: '5dce8d43ecd44f1980cf0024', name: 'Kheri'},
    {_id: '5dce8d43ecd44f1980cf0025', name: 'Kushinagar'},
    {_id: '5dd4e16bba02ad50c686b952', name: 'Lakhimpur Kheri'},
    {_id: '5dce8d43ecd44f1980cf0026', name: 'Lalitpur'},
    {_id: '5dce8d43ecd44f1980cf0027', name: 'Lucknow'},
    {_id: '5dce8d43ecd44f1980cf0029', name: 'Maharajganj'},
    {_id: '5dce8d43ecd44f1980cf0028', name: 'Mahoba'},
    {_id: '5dce8d43ecd44f1980cf002a', name: 'Mainpuri'},
    {_id: '5dce8d43ecd44f1980cf002b', name: 'Mathura'},
    {_id: '5dce8d43ecd44f1980cf002c', name: 'Mau'},
    {_id: '5dce8d43ecd44f1980cf002d', name: 'Meerut'},
    {_id: '5dce8d43ecd44f1980cf002e', name: 'Mirzapur'},
    {_id: '5dce8d43ecd44f1980cf002f', name: 'Moradabad'},
    {_id: '5dce8d43ecd44f1980cf0030', name: 'Muzaffarnagar'},
    {_id: '5dce8d43ecd44f1980cf0031', name: 'Pilibhit'},
    {_id: '5dce8d43ecd44f1980cf0032', name: 'Pratapgarh'},
    {_id: '5dce8d43ecd44f1980cefffb', name: 'Prayagraj'},
    {_id: '5dce8d43ecd44f1980cf0033', name: 'Rae Bareli'},
    {_id: '5dce8d43ecd44f1980cf0034', name: 'Rampur'},
    {_id: '5dce8d43ecd44f1980cf0035', name: 'Saharanpur'},
    {_id: '5dd4e16bba02ad50c686b950', name: 'Sambhal'},
    {_id: '5dce8d43ecd44f1980cf0036', name: 'Sant Kabir Nagar'},
    {_id: '5dce8d43ecd44f1980cf0037', name: 'Sant Ravidas Nagar'},
    {_id: '5dce8d43ecd44f1980cf0038', name: 'Shahjahanpur'},
    {_id: '5dce8d43ecd44f1980cf0039', name: 'Shrawasti'},
    {_id: '5dce8d43ecd44f1980cf003a', name: 'Siddharthnagar'},
    {_id: '5dce8d43ecd44f1980cf003b', name: 'Sitapur'},
    {_id: '5dce8d43ecd44f1980cf003c', name: 'Sonbhadra'},
    {_id: '5dce8d43ecd44f1980cf003d', name: 'Sultanpur'},
    {_id: '5dce8d43ecd44f1980cf003e', name: 'Unnao'},
    {_id: '5dce8d43ecd44f1980cf003f', name: 'Varanasi'},
  ],
  Gujarat: [
    {_id: '60f4666196d7b3151afffbf2', name: 'Ahmadabad'},
    {_id: '60f4666196d7b3151afffb99', name: 'Amreli'},
    {_id: '60f4666196d7b3151afffce6', name: 'Anand'},
    {_id: '60f4666196d7b3151afffce5', name: 'Arvalli'},
    {_id: '60f4666196d7b3151afffbc6', name: 'Banas Kantha'},
    {_id: '60f4666196d7b3151afffb61', name: 'Bharuch'},
    {_id: '60f4666196d7b3151afffcfd', name: 'Bhavnagar'},
    {_id: '60f4666196d7b3151afffd37', name: 'Botad'},
    {_id: '60f4666196d7b3151afffccb', name: 'Chhotaudepur'},
    {_id: '60f4666196d7b3151afffc16', name: 'Dang'},
    {_id: '60f4666196d7b3151afffc4e', name: 'Devbhumi Dwarka'},
    {_id: '60f4666196d7b3151afffc9c', name: 'Dohad'},
    {_id: '60f4666196d7b3151afffc5e', name: 'Gandhinagar'},
    {_id: '60f4666196d7b3151afffd10', name: 'Gir Somnath'},
    {_id: '60f4666196d7b3151afffbd5', name: 'Jamnagar'},
    {_id: '60f4666196d7b3151afffb9e', name: 'Junagadh'},
    {_id: '60f4666196d7b3151afffbdb', name: 'Kachchh'},
    {_id: '60f4666196d7b3151afffd16', name: 'Kerala'},
    {_id: '60f4666196d7b3151afffcb7', name: 'Kheda'},
    {_id: '60f4666196d7b3151afffd00', name: 'Mahesana'},
    {_id: '60f4666196d7b3151afffc1d', name: 'Mahisagar'},
    {_id: '60f4666196d7b3151afffc48', name: 'Morbi'},
    {_id: '60f4666196d7b3151afffd15', name: 'Narmada'},
    {_id: '60f4666196d7b3151afffc58', name: 'Navsari'},
    {_id: '60f4666196d7b3151afffc76', name: 'Panch Mahals'},
    {_id: '60f4666196d7b3151afffc68', name: 'Patan'},
    {_id: '60f4666196d7b3151afffd04', name: 'Porbandar'},
    {_id: '60f4666196d7b3151afffb5e', name: 'Rajkot'},
    {_id: '60f4666196d7b3151afffb7b', name: 'Sabar Kantha'},
    {_id: '60f4666196d7b3151afffc4c', name: 'Surat'},
    {_id: '60f4666196d7b3151afffb64', name: 'Surendranagar'},
    {_id: '60f4666196d7b3151afffd2f', name: 'Tapi'},
    {_id: '60f4666196d7b3151afffb8b', name: 'Vadodara'},
    {_id: '60f4666196d7b3151afffc09', name: 'Valsad'},
  ],
  Meghalaya: [
    {_id: '60f4666196d7b3151afffc12', name: 'East Garo Hills'},
    {_id: '60f4666196d7b3151afffc08', name: 'East Jaintia Hills'},
    {_id: '60f4666196d7b3151afffd07', name: 'East Khasi Hills'},
    {_id: '60f4666196d7b3151afffbba', name: 'Ri Bhoi'},
    {_id: '60f4666196d7b3151afffc20', name: 'South Garo Hills'},
    {_id: '60f4666196d7b3151afffc0c', name: 'West Garo Hills'},
    {_id: '60f4666196d7b3151afffcb8', name: 'West Jaintia Hills'},
    {_id: '60f4666196d7b3151afffb7c', name: 'West Khasi Hills'},
  ],
'Andhra Pradesh': [
  { _id: '60f4666196d7b3151afffc88', name: 'Alluri Sitharama Raju' },
  { _id: '60f4666196d7b3151afffbc5', name: 'Anakapalli' },
  { _id: '60f4666196d7b3151afffc02', name: 'Ananthapuramu' },
  { _id: '60f4666196d7b3151afffd22', name: 'Annamayya' },
  { _id: '60f4666196d7b3151afffcd6', name: 'Bapatla' },
  { _id: '60f4666196d7b3151afffbe7', name: 'Chittoor' },
  { _id: '60f4666196d7b3151afffbf1', name: 'Dr. B.R. Ambedkar Konaseema' },
  { _id: '60f4666196d7b3151afffc2e', name: 'East Godavari' },
  { _id: '60f4666196d7b3151afffceb', name: 'Eluru' },
  { _id: '60f4666196d7b3151afffcaf', name: 'Guntur' },
  { _id: '60f4666196d7b3151afffd21', name: 'Kakinada' },
  { _id: '60f4666196d7b3151afffd02', name: 'Krishna' },
  { _id: '60f4666196d7b3151afffd25', name: 'Kurnool' },
  { _id: '60f4666196d7b3151afffbc2', name: 'Nandyal' },
  { _id: '60f4666196d7b3151afffd11', name: 'NTR' },
  { _id: '60f4666196d7b3151afffd12', name: 'Palnadu' },
  { _id: '60f4666196d7b3151afffd13', name: 'Parvathipuram Manyam' },
  { _id: '60f4666196d7b3151afffd14', name: 'Prakasam' },
  { _id: '60f4666196d7b3151afffd15', name: 'Sri Potti Sriramulu Nellore' },
  { _id: '60f4666196d7b3151afffd16', name: 'Sri Sathya Sai' },
  { _id: '60f4666196d7b3151afffd17', name: 'Srikakulam' },
  { _id: '60f4666196d7b3151afffd18', name: 'Tirupati' },
  { _id: '60f4666196d7b3151afffd19', name: 'Visakhapatnam' },
  { _id: '60f4666196d7b3151afffd20', name: 'Vizianagaram' },
  { _id: '60f4666196d7b3151afffd23', name: 'West Godavari' },
  { _id: '60f4666196d7b3151afffd24', name: 'Y.S.R. Kadapa' },
],
  Bihar: [
    {_id: '5dce8d42ecd44f1980cefe86', name: 'Araria'},
    {_id: '5dce8d42ecd44f1980cefe87', name: 'Arwal'},
    {_id: '5dce8d42ecd44f1980cefe88', name: 'Aurangabad'},
    {_id: '5dce8d42ecd44f1980cefe89', name: 'Banka'},
    {_id: '5dce8d42ecd44f1980cefe8a', name: 'Begusarai'},
    {_id: '5dce8d42ecd44f1980cefe8b', name: 'Bhagalpur'},
    {_id: '5dce8d42ecd44f1980cefe8c', name: 'Bhojpur'},
    {_id: '5dce8d42ecd44f1980cefe8d', name: 'Buxar'},
    {_id: '5dce8d42ecd44f1980cefe8e', name: 'Darbhanga'},
    {_id: '5dce8d42ecd44f1980cefe8f', name: 'Gaya'},
    {_id: '5dce8d42ecd44f1980cefe90', name: 'Gopalganj'},
    {_id: '5dce8d42ecd44f1980cefe91', name: 'Jamui'},
    {_id: '5dce8d42ecd44f1980cefe92', name: 'Jehanabad'},
    {_id: '5dce8d42ecd44f1980cefe93', name: 'Kaimur'},
    {_id: '5dce8d42ecd44f1980cefe94', name: 'Katihar'},
    {_id: '5dce8d42ecd44f1980cefe95', name: 'Khagaria'},
    {_id: '5dce8d42ecd44f1980cefe96', name: 'Kishanganj'},
    {_id: '5dce8d42ecd44f1980cefe97', name: 'Lakhisarai'},
    {_id: '5dce8d42ecd44f1980cefe98', name: 'Madhepura'},
    {_id: '5dce8d42ecd44f1980cefe99', name: 'Madhubani'},
    {_id: '5dce8d42ecd44f1980cefe9a', name: 'Munger'},
    {_id: '5dce8d42ecd44f1980cefe9b', name: 'Muzaffarpur'},
    {_id: '5dce8d42ecd44f1980cefe9c', name: 'Nalanda'},
    {_id: '5dce8d42ecd44f1980cefe9d', name: 'Nawada'},
    {_id: '5dce8d42ecd44f1980cefe9e', name: 'Pashchim Champaran'},
    {_id: '5dce8d42ecd44f1980cefe9f', name: 'Patna'},
    {_id: '5dce8d42ecd44f1980cefea1', name: 'Purnia'},
    {_id: '5dce8d42ecd44f1980cefea0', name: 'Purvi Champaran'},
    {_id: '5dce8d42ecd44f1980cefea2', name: 'Rohtas'},
    {_id: '5dce8d42ecd44f1980cefea3', name: 'Saharsa'},
    {_id: '5dce8d42ecd44f1980cefea4', name: 'Samastipur'},
    {_id: '5dce8d42ecd44f1980cefea5', name: 'Saran'},
    {_id: '5dce8d42ecd44f1980cefea6', name: 'Sheikhpura'},
    {_id: '5dce8d42ecd44f1980cefea7', name: 'Sheohar'},
    {_id: '5dce8d42ecd44f1980cefea8', name: 'Sitamarhi'},
    {_id: '5dce8d42ecd44f1980cefea9', name: 'Siwan'},
    {_id: '5dce8d42ecd44f1980cefeaa', name: 'Supaul'},
    {_id: '5dce8d42ecd44f1980cefeab', name: 'Vaishali'},
  ],
  Punjab: [
    {_id: '60f4666196d7b3151afffb60', name: 'Amritsar'},
    {_id: '60f4666196d7b3151afffd24', name: 'Barnala'},
    {_id: '60f4666196d7b3151afffcea', name: 'Bathinda'},
    {_id: '60f4666196d7b3151afffc5a', name: 'Faridkot'},
    {_id: '60f4666196d7b3151afffc94', name: 'Fatehgarh Sahib'},
    {_id: '60f4666196d7b3151afffb71', name: 'Fazilka'},
    {_id: '60f4666196d7b3151afffbf5', name: 'Firozepur'},
    {_id: '60f4666196d7b3151afffb5d', name: 'Gurdaspur'},
    {_id: '60f4666196d7b3151afffc5c', name: 'Hoshiarpur'},
    {_id: '60f4666196d7b3151afffc1b', name: 'Jalandhar'},
    {_id: '60f4666196d7b3151afffb9d', name: 'Kapurthala'},
    {_id: '60f4666196d7b3151afffd12', name: 'Ludhiana'},
    {_id: '60f4666196d7b3151afffc99', name: 'Mansa'},
    {_id: '60f4666196d7b3151afffbc7', name: 'Moga'},
    {_id: '60f4666196d7b3151afffca8', name: 'Pathankot'},
    {_id: '60f4666196d7b3151afffbfc', name: 'Patiala'},
    {_id: '60f4666196d7b3151afffcb6', name: 'Rupnagar'},
    {_id: '60f4666196d7b3151afffbe6', name: 'S.A.S Nagar'},
    {_id: '60f4666196d7b3151afffc0a', name: 'SRI MUKTSAR SAHIB'},
    {_id: '60f4666196d7b3151afffcad', name: 'Sangrur'},
    {
      _id: '60f4666196d7b3151afffc2b',
      name: 'Shahid Bhagat Singh Nagar',
    },
    {_id: '60f4666196d7b3151afffd2b', name: 'Sri Muktsar Sahib'},
    {_id: '60f4666196d7b3151afffce8', name: 'TARN TARAN'},
    {_id: '60f4666196d7b3151afffb85', name: 'Tarn Taran'},
  ],
  Lakshadweep: [
    {_id: '60f4666196d7b3151afffc0b', name: 'Lakshadweep District'},
  ],
};

export default districts;
export { districts };
